<template>
  <div class="card card-custom h-100" id="cardGrafico">
    <v-overlay :value="carregando" :absolute="true">
      <v-progress-circular indeterminate size="32" color="#462181" width="2"
        ><v-progress-circular
          indeterminate
          size="24"
          color="#ff7f00"
          width="2"
          rotate="180"
        ></v-progress-circular
      ></v-progress-circular>
    </v-overlay>

    <div class="card-body p-0 d-flex flex-column">
      <div
        class="d-flex align-items-center justify-content-between card-spacer"
      >
        <div class="d-flex align-items-center">
          <span class="card-titulo-icone mr-3"
            ><i class="fas fa-comments"></i
          ></span>
          <h5 class="m-0 mr-3 card-titulo">Mensagens</h5>
          <Tooltip
            message="O gráfico e a legenda demonstram as mensagens recebidas, as mensagens enviadas e os erros referentes ao período de tempo selecionado."
          />
        </div>
        <div class="d-flex align-items-center">
          <button
            type="button"
            class="card-acao mr-2"
            @click.prevent="abrirRelatorio()"
          >
            <i class="fas fa-chart-column"></i>
            Ver relatório
          </button>
          <slot></slot>
          <div>
            <b-button
              variant="success"
              size="sm"
              class="ml-2"
              style="
                background: #472282 !important;
                border-color: #472282 !important;
              "
              @click="toggle"
              ref="BotaoMenu"
            >
              {{ label_botao_menu }}
            </b-button>
            <div
              class="d-flex justify-content-center"
              style="position: relative"
              v-if="visible_menu_opcoes"
            >
              <Menu
                ref="menu_togglable"
                id="overlay_menu"
                :model="messageChannelFilterOptions"
                style="
                  position: absolute;
                  transform: translateY(4px);
                  z-index: 99;
                  right: 0;
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="d-flex flex-column align-items-center w-100 h-100 pb-3"
        style="justify-content: space-evenly"
      >
        <apexchart
          class="card-rounded-bottom w-100"
          :options="opcoesGrafico"
          :series="series"
          type="area"
          width="100%"
        ></apexchart>
        <!-- Mesma linguagem dos cards da Timeline: fundo tonal, borda na
        cor do tipo e icone em pilula. -->
        <div class="totais">
          <button
            type="button"
            class="totais__item totais__item--envio"
            title="Ver relatório de envios"
            @click="abrirRelatorio('ENV')"
          >
            <span class="totais__icone"
              ><i class="fas fa-paper-plane"></i
            ></span>
            <div class="totais__dados">
              <div class="totais__valor">{{ enviosLineChart }}</div>
              <div class="totais__rotulo">Envios</div>
            </div>
          </button>
          <button
            type="button"
            class="totais__item totais__item--recebimento"
            title="Ver relatório de recebimentos"
            @click="abrirRelatorio('REC')"
          >
            <span class="totais__icone"
              ><i class="fas fa-comment-dots"></i
            ></span>
            <div class="totais__dados">
              <div class="totais__valor">{{ recebimentosLineChart }}</div>
              <div class="totais__rotulo">Recebimentos</div>
            </div>
          </button>
          <button
            type="button"
            class="totais__item totais__item--erro"
            title="Ver relatório de erros"
            @click="abrirRelatorio('ERR')"
          >
            <span class="totais__icone"
              ><i class="fas fa-circle-exclamation"></i
            ></span>
            <div class="totais__dados">
              <div class="totais__valor">{{ errosLineChart }}</div>
              <div class="totais__rotulo">Erros</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Tooltip from "./Tooltip.vue";
import Menu from "primevue/menu";

export default {
  components: { Tooltip, Menu },
  props: {
    total_aglutinado_series: {
      required: true
    },
    series_whatsapp: {
      required: true
    },
    series_sms: {
      required: true
    },
    total_aglutinado: {
      required: true
    },
    total_whatsapp: {
      required: true
    },
    total_sms: {
      required: true
    },
    titulo: {
      required: true
    },
    tipo: {
      required: true
    },
    periodo: {
      required: true
    },
    carregando: {
      required: true
    }
  },
  name: "grafico",
  data() {
    return {
      series: [],
      opcoesGrafico: {},
      visible_menu_opcoes: false,
      label_botao_menu: "WhatsApp"
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    messageChannelFilterOptions() {
      const options = [
        {
          label: "Todos",
          command: this.clickAll
        },
        {
          label: "WhatsApp",
          command: this.clickWpp
        },
        {
          label: "SMS",
          command: this.clickSMS
        }
      ];
      if (this.total_sms == 0) {
        options.splice(0, 1);
        options.splice(1, 2);
      }
      if (this.total_whatsapp == 0) {
        options.splice(0, 2);
      }
      return options;
    },
    enviosLineChart() {
      if (this.label_botao_menu == "WhatsApp") {
        const envios = this.series_whatsapp.find(
          (serie) => serie.name === "Envios"
        );
        if (envios) {
          let sum = 0;
          envios.data.forEach((envio) => {
            sum += +envio.y;
          });
          return sum;
        }
        return 0;
      } else if (this.label_botao_menu == "SMS") {
        const envios = this.series_sms.find((serie) => serie.name === "Envios");
        if (envios) {
          let sum = 0;
          envios.data.forEach((envio) => {
            sum += +envio.y;
          });
          return sum;
        }
        return 0;
      }
      const envios = this.total_aglutinado_series.find(
        (serie) => serie.name === "Envios"
      );
      if (envios) {
        let sum = 0;
        envios.data.forEach((envio) => {
          sum += +envio.y;
        });
        return sum;
      }
      return 0;
    },
    recebimentosLineChart() {
      if (this.label_botao_menu == "WhatsApp") {
        const recebimentos = this.series_whatsapp.find(
          (serie) => serie.name === "Recebimentos"
        );
        if (recebimentos) {
          let sum = 0;
          recebimentos.data.forEach((recebimento) => {
            sum += +recebimento.y;
          });
          return sum;
        }
        return 0;
      } else if (this.label_botao_menu == "SMS") {
        const recebimentos = this.series_sms.find(
          (serie) => serie.name === "Recebimentos"
        );
        if (recebimentos) {
          let sum = 0;
          recebimentos.data.forEach((recebimento) => {
            sum += +recebimento.y;
          });
          return sum;
        }
        return 0;
      }
      const recebimentos = this.total_aglutinado_series.find(
        (serie) => serie.name === "Recebimentos"
      );
      if (recebimentos) {
        let sum = 0;
        recebimentos.data.forEach((recebimento) => {
          sum += +recebimento.y;
        });
        return sum;
      }
      return 0;
    },
    errosLineChart() {
      if (this.label_botao_menu == "WhatsApp") {
        const erros = this.series_whatsapp.find(
          (serie) => serie.name === "Erros"
        );
        if (erros) {
          let sum = 0;
          erros.data.forEach((erro) => {
            sum += +erro.y;
          });
          return sum;
        }
        return 0;
      } else if (this.label_botao_menu == "SMS") {
        const erros = this.series_sms.find((serie) => serie.name === "Erros");
        if (erros) {
          let sum = 0;
          erros.data.forEach((erro) => {
            sum += +erro.y;
          });
          return sum;
        }
        return 0;
      }
      const erros = this.total_aglutinado_series.find(
        (serie) => serie.name === "Erros"
      );
      if (erros) {
        let sum = 0;
        erros.data.forEach((erro) => {
          sum += +erro.y;
        });
        return sum;
      }
      return 0;
    }
  },
  mounted() {
    this.opcoesGrafico = {
      colors: ["#f64e60", "#472282", "#ff7f00"],
      chart: {
        height: 200,
        type: "area",
        stacked: true,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      // Linha marcada e area clara: assim o grafico contrasta com os
      // cards ao redor em vez de competir com eles em peso visual.
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 0,
          opacityFrom: 0.28,
          opacityTo: 0.06,
          stops: [0, 100]
        }
      },
      legend: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: "smooth",
        width: 2.5,
        colors: ["#f64e60", "#472282", "#ff7f00"]
      },
      xaxis: {
        type: "datetime",
        labels: {
          show: false
        },
        tooltip: {
          enabled: false
        }
      },
      yaxis: {
        labels: {
          formatter: function (valor) {
            return valor.toFixed(0);
          },
          oposite: true
        }
      }
    };
    if (this.total_whatsapp != 0 && this.total_sms != 0) {
      this.clickAll();
    } else if (this.total_whatsapp == 0 && this.total_sms > 0) {
      this.clickSMS();
    } else {
      this.updateApexWpp();
    }
  },
  methods: {
    updateFromPicker() {
      if (this.label_botao_menu == "WhatsApp") {
        this.updateApexWpp();
      } else if (this.label_botao_menu == "SMS") {
        this.updateApexSMS();
      } else {
        this.updateApexAll();
      }
    },
    clickAll() {
      this.label_botao_menu = "Todos";
      this.$refs.BotaoMenu.style.background = "#472282";
      this.$refs.BotaoMenu.style.borderColor = "#472282";
      this.updateApexAll();
      this.closeMenu();
    },
    clickWpp() {
      this.label_botao_menu = "WhatsApp";
      this.$refs.BotaoMenu.style.background = "#00a884";
      this.$refs.BotaoMenu.style.borderColor = "#00a884";
      this.updateApexWpp();
      this.closeMenu();
    },
    clickSMS() {
      this.label_botao_menu = "SMS";
      this.$refs.BotaoMenu.style.background = "#ff7f00";
      this.$refs.BotaoMenu.style.borderColor = "#ff7f00";
      this.updateApexSMS();
      this.closeMenu();
    },
    // status: quando vem de um dos cards de totais (Envios/Recebimentos/
    // Erros), ja abre o relatorio filtrado por aquele status.
    abrirRelatorio(status = null) {
      const params = { periodo: this.periodo };
      if (status) {
        params.statusFiltro = [status];
      }
      this.$router.push({
        name: "relatorio-detalhado",
        params
      });
    },
    closeMenu() {
      this.visible_menu_opcoes = false;
    },
    toggle() {
      this.visible_menu_opcoes = !this.visible_menu_opcoes;
    },
    updateApexWpp() {
      this.series = JSON.parse(JSON.stringify(this.series_whatsapp));
    },
    updateApexAll() {
      this.series = JSON.parse(JSON.stringify(this.total_aglutinado_series));
    },
    updateApexSMS() {
      this.series = JSON.parse(JSON.stringify(this.series_sms));
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  transition: 0.3s ease;
  &:hover {
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  }
}
.text-muted {
  color: #434658 !important;
}

// WEL-5194: totais em cards, na mesma linguagem dos eventos da Timeline.
// Em coluna estreita os tres lado a lado cortavam o rotulo; a partir de
// ~1400px eles voltam pra mesma linha, e abaixo disso quebram em duas.
.totais {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 0 1.5rem 0.5rem;
}

.totais__item {
  flex: 1 1 190px;
  min-width: 190px;
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  border: 2.5px solid transparent;

  // Viraram <button> pra abrir o relatorio filtrado; reset do estilo nativo.
  text-align: left;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: rgba(100, 100, 111, 0.15) 0px 4px 12px 0px;
  }
}

.totais__icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #fff;
  flex: 0 0 34px;

  i {
    font-size: 1rem !important;
  }
}

.totais__valor {
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.1;
  color: #2b2640;
}

.totais__dados {
  min-width: 0;
}

.totais__rotulo {
  font-size: 0.75rem;
  font-weight: 600;
  color: #7c7c8a;
  white-space: nowrap;
}

@mixin total-cor($cor, $fundo) {
  background: $fundo;
  border-color: rgba($cor, 0.35);

  .totais__icone i {
    color: $cor !important;
  }
}

.totais__item--envio {
  @include total-cor(#ff7f00, #fff5ea);
}

.totais__item--recebimento {
  @include total-cor(#472282, #f2eefa);
}

.totais__item--erro {
  @include total-cor(#f64e60, #fdedee);
}
</style>
